/* eslint-disable no-shadow,consistent-return,no-param-reassign */
import ApiAuthentication from '@/services/ApiAuthentication';
import ApiProfile from '@/services/ApiProfile';
import router from '@/routers';

const state = {};

const getters = {};

const mutations = {};

const actions = {
    async login({ commit, dispatch }, payload) {
        try {
            commit('StoreLoading/showLoading', '', { root: true });

            const res = await ApiAuthentication.login(payload);

            localStorage.setItem('token', res.data.token);
            await dispatch('getProfile');
            commit('StoreLoading/hideLoading', '', { root: true });
            router.replace('/home');
        } catch (error) {
            commit('StoreLoading/hideLoading', '', { root: true });
            throw error;
        }
    },

    async getProfile() {
        try {
            const res = await ApiProfile.getProfile();
            const item = {
                ...res.data.data,
                img: '/assets/logo-user.png',
                date: 'Last seen today 15:24',
                title: res.data.data.name
            };
            localStorage.setItem('user', JSON.stringify(item));
        } catch (error) {
            throw error;
        }
    }
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
};